import axios from "axios";
import { useQuery } from "react-query";

/**
 * The "dates that matter" filter options: the per-content-type "date that matters"
 * map + data-driven period options, each carrying its baked { from, to },
 * `interval` and ready-to-use `findQuery`.
 *
 * Same payload as the `date` key of the Lenses 2 bootstrap context, served by
 * its own endpoint so surfaces that need only these options (the Topics tab's
 * period filter) skip the tag-group + demographic work /context also does.
 *
 * Lenses 2 itself keeps using useGetLensesContext — it needs the rest of that
 * payload anyway, and the BE serves both from one service, so the two period
 * lists cannot drift.
 */
export const useGetDatesThatMatterFilterOptions = ({ enabled = true } = {}) =>
  useQuery(
    "datesThatMatterFilterOptions",
    () => axios.get("/api/lenses/v2/datesThatMatterFilterOptions").then((r) => r.data),
    { staleTime: 5 * 60 * 1000, enabled }
  );
